var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEvolbsIcon6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_2_24",
    "data-name": "Component 2 \\u2013 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.452,
    height: 23.451,
    viewBox: "0 0 23.452 23.451",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M176.332,80.053a27.975,27.975,0,0,0-11.3,0,7.055,7.055,0,0,0-5.5,5.5,27.94,27.94,0,0,0,0,11.3,7.054,7.054,0,0,0,5.5,5.5,27.963,27.963,0,0,0,11.3,0,7.054,7.054,0,0,0,5.5-5.5,27.945,27.945,0,0,0,0-11.3,7.055,7.055,0,0,0-5.5-5.5m4.559,13.708h-5.185a2.56,2.56,0,0,1,0-5.12h5.185c.017,0,.033,0,.05,0a26.537,26.537,0,0,1,0,5.13c-.017,0-.033-.005-.05-.005m-.373,2.821a5.714,5.714,0,0,1-4.455,4.455,26.6,26.6,0,0,1-10.761,0,5.714,5.714,0,0,1-4.455-4.455,26.622,26.622,0,0,1,0-10.761,5.713,5.713,0,0,1,4.455-4.454,26.613,26.613,0,0,1,10.761,0,5.713,5.713,0,0,1,4.455,4.454c.1.492.187.987.26,1.48h-5.072a3.9,3.9,0,1,0,0,7.8h5.072q-.11.742-.26,1.481",
    transform: "translate(-158.956 -79.476)",
    fill: "#4e428d"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M182.525,94.16h-1.159a.67.67,0,1,0,0,1.34h1.159a.67.67,0,1,0,0-1.34",
    transform: "translate(-164.327 -83.104)",
    fill: "#4e428d"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvolbsIcon6);
export default __webpack_public_path__ + "static/media/evolbs_icon6.18ddc9bf.svg";
export { ForwardRef as ReactComponent };